import { ReactNode } from 'react';

import { useAppSelector } from '@sternum/web/store';

import { ThemeProvider } from './Theme.provider';

export interface MainThemeProviderProps {
  children?: ReactNode;
}

export function MainThemeProvider({ children }: MainThemeProviderProps) {
  const mode = useAppSelector((state) => state.mainThemeMode.mode);

  return <ThemeProvider mode={mode}>{children}</ThemeProvider>;
}
